import React, {useState, useEffect} from "react";
import {Routes, Route, useNavigate, Link, useParams} from 'react-router-dom';
import moment from 'moment';
import {  Table, Select, DatePicker, Spin, Input, Breadcrumb, Progress, Empty, Typography, Skeleton,Menu, Col, Row, Statistic ,Card } from 'antd';
import {  HomeOutlined, DollarCircleOutlined } from '@ant-design/icons';
import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';
import Spinner from '../../components/spinner'

const { Option } = Select;
const sportColorMap = {
  Football: '#FFD500',  
  Badminton: '#87a3ef',
  Swimming: '#9370db',  
  Pickleball: '#02475c',
  Cricket: '#65468a',   
  Skating: '#337ab7',
};

const CollectionListSummary = () => {
  const navigate = useNavigate();
  const { venue_id, type } = useParams();
  var local_selectedVenueId = venue_id
  var local_month = JSON.parse(localStorage.getItem('month'));
  var local_year = JSON.parse(localStorage.getItem('year'));

  const [loading, setLoading] = useState(true)
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [month, setMonth] = useState(local_month)
  const [year, setYear] = useState(local_year)
  const [venueName, setVenueName] = useState('')
  const [selectedGame, setSelectedGame] = useState('')
  const [sportDetails, setSportDetails] = useState([])
  const [stats, setStats] = useState([])
  const [loader, setloader] = useState(false)
  const [monthYear,setMonthYear] = useState('')

  useEffect(() => {
    setLoading(true)
    if(selectedVenueId && month && year){
      getCollectionSplitBySport()
    }
  }, [selectedVenueId,month,year]);

  const getCourtBookingAnalysis= (sport) => {
    setloader(true)
    getData(`/business/get_court_booking_breakup/?month=${month}&year=${year}&venue_id=${selectedVenueId}&sport_name=${sport}`)
    .then(response =>{
      setStats(response.results)
      setMonthYear(response.month)
      setloader(false)
    })
    .catch(error => {
      setloader(false)
      console.log(error.message);
    });
  }

  const getCollectionSplitBySport = () => {
    getData(`/business/get_collection_breakup_by_sport/?month=${month}&year=${year}&venue_id=${selectedVenueId}`)
    .then(response =>{
      setSportDetails(response.result)
      setVenueName(response.venue_name)
      if(response.result[0]){
        onGameSelect(response.result[0].game)
      }
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const onChangeYear = (date, dateString) => {
    setYear(dateString);
  }

  const formatIndianCurrency = (value) => {
    return Number(value).toLocaleString('en-IN')
  };

  const onGameSelect = (game) =>{
    setSelectedGame(game)
    getCourtBookingAnalysis(game)
  }

  const columns = [
    {
      title: monthYear ? monthYear : '',
      dataIndex: 'type',
      align: 'center',
    },
    {
      title: 'Total Collection',
      dataIndex: 'total',
      align: 'center',
      render: text => formatIndianCurrency(text),
    },
    {
      title: 'Verified',
      dataIndex: 'verified',
      align: 'center',
      render: text => formatIndianCurrency(text),
    },
    {
      title: 'Unverified',
      dataIndex: 'unverified',
      align: 'center',
      render: text => formatIndianCurrency(text),
    },
  ];

  return (
    <Spin spinning={loading} indicator={<Spinner />}>

      <Styled.MainContainer>

        <Styled.TopDiv> 
          <Breadcrumb style={{padding:'10px'}} >
            <Breadcrumb.Item>
              <Link to="/">
                <HomeOutlined />
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
              <Link to="/collection">
                <DollarCircleOutlined />
                <span style={{paddingLeft:'5px'}}>Collection</span>
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>{venueName}</Breadcrumb.Item>
          </Breadcrumb>

          <div style={{display: 'flex'}}>
            <Styled.Selector>
              <Select
                  className = 'mainSelector'
                  style={{width: 150}}
                  onChange={setMonth}
                  value = {month}
                  bordered={false}
                >
                  <Option value="12"> December </Option>
                  <Option value="11"> November </Option>
                  <Option value="10"> October </Option>
                  <Option value="09"> September </Option>
                  <Option value="08"> August </Option>
                  <Option value="07"> July </Option>
                  <Option value="06"> June </Option>
                  <Option value="05"> May </Option>
                  <Option value="04"> April </Option>
                  <Option value="03"> March </Option>
                  <Option value="02"> February </Option>
                  <Option value="01"> January </Option>
                </Select>
              </Styled.Selector>

              <Styled.Selector>
                <div className = 'mainSelector'>
                  <DatePicker defaultValue={moment(year, 'YYYY')}  onChange = {onChangeYear}  bordered={false}  picker="year" />
                </div> 
            </Styled.Selector>
          </div>
        </Styled.TopDiv>

        {sportDetails && sportDetails.length > 0 ? 
        <>
          <Styled.SportsContainer>
            {sportDetails.map(({ game, collection, customers, percent}) => {
              const color = sportColorMap[game] || '#ccc'
              return(
              <Styled.SportsTab key={game} active={game == selectedGame} onClick={()=>onGameSelect(game)}>
                <div style={{ fontWeight: 600, fontSize: '18px'}}>{game}</div>
                <Progress type="circle" percent={percent} strokeColor={percent === 100 ? '#52c41a' : color} format={p =>  <span style={{ color: '#02475c' }}>{p}%</span>} width={75}/>
                <div style={{fontSize: '14px'}}>
                  ₹{collection.toLocaleString('en-IN')}
                </div>
                <div style={{ fontSize: '12px'}}>
                  {customers} {customers === 1 ? 'customer' : 'customers'}
                </div>
              </Styled.SportsTab>)
            })}
          </Styled.SportsContainer>
          {stats && 
            <div style={{padding: 10}}>
              <Menu mode="horizontal">
                <Menu.Item key="summary">Summary</Menu.Item>
              </Menu>
              <div style={{ marginTop: '1%' }}>
                  <div>
                    {loader ?
                      <Skeleton active paragraph={{ rows: 7 }} />
                    :
                      <Table columns={columns} dataSource={stats} size="middle" pagination={false}/>
                    }
                  </div>
              </div>
            </div>
          }
        </>
        :
          <Empty style={{marginTop: '10%'}} description = {<span style={{color: 'grey', fontSize: 'small'}}> data not available </span>} />
        }
      </Styled.MainContainer>
    </Spin>
  );
}

export default CollectionListSummary;